import { daysBetweenNowAndDate } from './daysBetweenNowAndDate';

export const daysRemaining = (expirationDate: Date) => {
  return Math.max(0, daysBetweenNowAndDate(expirationDate));
};
